import React from "react";

import { MinicartLineItem } from "./MinicartLineItem";

type MinicartItemsProps = {
  items?: any,
  settings?: any,
  global_settings?: any,
}

export const MinicartItems = ({
  items = [],
  settings = {},
  global_settings = {}
}: MinicartItemsProps) => {
  const { globals } = global_settings;
  const {
    background_color = "#ffffff",
    direction = "column",
    border_radius = "6px",
    margin_bottom = 20,
    padding = 0,
    item_gap = 10,
    border = "none",
  } = settings;

  // Dynamically create style objects
  const containerStyle = {
    backgroundColor: background_color,
    borderRadius: border_radius,
    marginBottom: `${margin_bottom}px`,
    padding: `${padding}px`,
    display: "flex",
    flexDirection: direction,
    border,
    gap: `${item_gap}px`
  };

  return (
    <div className="minicart-items" style={containerStyle}>
      <ul className="minicart-items__list list-none p-0 w-full">
        {items.map((item, index) => (
          <MinicartLineItem
            key={item.key || index}
            item={item}
            settings={settings}
            globals={globals}
          />
        ))}
      </ul>
    </div>
  );
};